import { ServerTokenService } from "../services/server-token.service";

export class FileUtils {
    static server: ServerTokenService;
    static changeNameToDisplayName(obj: any, pageName) {
        if(! obj) return;
        obj.displayName = obj['file_name'].split('_ListD')[0];
        if(obj.displayName[0] >= "0" && obj.displayName[0] <= "9") {
            obj.displayName = obj.displayName.substring(1);
            if(obj.displayName[0] >= "0" && obj.displayName[0] <= "9") {
                obj.displayName = obj.displayName.substring(1);
            }
    
        }
        const filePart = parseInt(obj['file_name'].split('_ListD')[1].split('.')[0]);
        obj.filePart = filePart;
        obj.displayPage = ((filePart - 1) * 25) + parseInt(obj[pageName]);
    }

    // docName, file_name
    // page_num, Page
    // const name = obj.file_name ? 'file_name' : 'docName';
    // const pageName = obj.page_num ? 'page_num' : 'Page';

    static numbersFields = [
        'Page',
        "Geometry.BoundingBox.Width",
        "Geometry.BoundingBox.Height",
        "Geometry.BoundingBox.Left",
        "Geometry.BoundingBox.Top",
        'bmi_val'
      ];

    static correctGenInfoObj(obj) {
        if(! obj['docName']) {
            return;
        }
        FileUtils.numbersFields.forEach(field => { if (obj[field]) obj[field] = parseFloat(obj[field]) })
        obj['file_name'] = obj['docName']?.replace("_OCR_text_only.json", "");
        FileUtils.changeNameToDisplayName(obj, 'Page');
    }

    static correctObj(obj) {
        if(! obj.file_name) {
            return;
        }
        const name = obj['file_name'].lastIndexOf('/') == -1 ? obj['file_name']: obj['file_name'].substring(obj['file_name'].lastIndexOf('/') + 1)
        obj['file_name'] = name?.replace("_OCR_text_only.txt", "");
        FileUtils.changeNameToDisplayName(obj, 'page_num');
    }

    static async donloadLocalFile(data, fileName) {
        let a: HTMLAnchorElement = document.getElementById('downloadA') as HTMLAnchorElement;
    
        if(!a) {
            a = document.createElement('a');
            a.style.display = 'none';
            document.body.appendChild(a);
        }
        const urlData  = window.URL.createObjectURL(data);

        a.href = urlData; //url as any;
        a.download = fileName;
        setTimeout(() => a.click(), 100);
    }

    static async downloadFile(key: string, fileName: string) {
        let a: HTMLAnchorElement = document.getElementById('downloadA') as HTMLAnchorElement;
    
        if(!a) {
            a = document.createElement('a');
            a.style.display = 'none';
            document.body.appendChild(a);
        }
        const res: any = await this.server.postWithToken('snfs/getPresignDownloadUrl', {key}).toPromise();
        const data = await fetch(res.url);
        const urlData  = window.URL.createObjectURL(await data.blob());

        a.href = urlData; //url as any;
        a.download = fileName;
        
        setTimeout(() => a.click(), 100);
    }
}